"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSeparatorContainer = exports.IconContainer = exports.ListCellContainer = exports.SideContainer = exports.MiddleContainer = exports.ListCellContentContainer = void 0;

var _designLanguage = require("@doordash/design-language");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _componentButton = require("@doordash/component-button");

var _componentSeparator = _interopRequireDefault(require("@doordash/component-separator"));

var _constants = require("./constants");

var _utilities = require("@doordash/utilities");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColumns = function getColumns(_ref) {
  var hasBeforeContent = _ref.hasBeforeContent,
      hasSecondaryTitleStart = _ref.hasSecondaryTitleStart,
      hasIconStart = _ref.hasIconStart,
      hasIconEnd = _ref.hasIconEnd,
      hasSecondaryTitleEnd = _ref.hasSecondaryTitleEnd,
      hasAfterContent = _ref.hasAfterContent,
      shouldTruncateSubContent = _ref.shouldTruncateSubContent;
  var columns = [];
  var primaryContentColumnString = shouldTruncateSubContent ? 'minmax(50%, 1fr)' : '1fr';
  columns.push(primaryContentColumnString);
  var subContentColumnString = shouldTruncateSubContent ? 'minmax(0, auto)' : 'auto';

  if (hasBeforeContent) {
    columns.unshift(subContentColumnString);
  }

  if (hasSecondaryTitleStart) {
    columns.unshift(subContentColumnString);
  }

  if (hasIconStart) {
    columns.unshift('auto');
  }

  if (hasAfterContent) {
    columns.push(subContentColumnString);
  }

  if (hasSecondaryTitleEnd) {
    columns.push(subContentColumnString);
  }

  if (hasIconEnd) {
    columns.push('auto');
  }

  return columns.join(' ');
};

var ListCellContentContainer = (0, _styledComponents["default"])(_designLanguage.Inset).attrs({
  size: function size(props) {
    return props.insetSize;
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 100%;\n  width: 100%;\n  display: grid;\n  grid-template-rows: auto auto auto;\n  grid-template-columns: ", ";\n  grid-column-gap: ", "px;\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    display: flex;\n    & > * + * {\n      margin-left: ", "px !important;\n    }\n  }\n"])), getColumns, function (props) {
  return props.columnGapSize;
}, function (props) {
  return props.columnGapSize;
});
exports.ListCellContentContainer = ListCellContentContainer;
var MiddleContainer = (0, _styledComponents["default"])(_designLanguage.StackChildren).attrs({
  size: _designLanguage.StackChildren.Sizes.None
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: hidden;\n  flex-basis: 100%;\n  grid-row: 2;\n  ", ";\n"])), function (props) {
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: ", ";\n  "])), 1 + props.hasBeforeContent + props.hasIconStart + props.hasSecondaryTitleStart);
});
exports.MiddleContainer = MiddleContainer;

var SideContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  align-self: ", ";\n  grid-row: 2;\n  ", ";\n"])), function (props) {
  return props.alignment;
}, function (props) {
  return (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-column: ", ";\n  "])), (props.side === _constants.Sides.Start ? 1 : 2 + props.hasSecondaryTitleStart) + props.hasBeforeContent + props.hasIconStart);
});

exports.SideContainer = SideContainer;
var ListCellContainer = (0, _utilities.withDynamicTag)(_styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n"])), function (props) {
  return (props.onClick || props.href) && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      cursor: pointer;\n      overflow: hidden;\n      text-decoration: none;\n      appearance: none;\n      border: none;\n      outline: none !important;\n      padding: 0;\n      margin: 0;\n      text-align: inherit;\n      display: block;\n      width: 100%;\n      background: ", ";\n      &:hover {\n        background: ", ";\n      }\n      &:active {\n        background: ", ";\n      }\n      &:focus {\n        position: relative;\n        z-index: 1;\n        ", ";\n      }\n    "])), props.themeColors.background, props.themeColors.hovered, props.themeColors.pressed, (0, _designLanguage.getFocusStyles)());
}));
exports.ListCellContainer = ListCellContainer;

var getIconButtonAdjustment = function getIconButtonAdjustment(size) {
  switch (size) {
    case _componentButton.IconButton.Sizes.Small:
      return -4;

    case _componentButton.IconButton.Sizes.Medium:
    default:
      return -8;
  }
};

var IconContainer = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  grid-row: 2;\n  ", ";\n  flex-shrink: 0;\n  line-height: 0;\n  display: flex;\n  align-items: ", ";\n  margin: ", "px;\n  ", ";\n  > svg {\n    ", ";\n  }\n"])), function (_ref2) {
  var side = _ref2.side,
      columnProps = _ref2.columnProps;
  return (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      grid-column: ", "};\n    "])), columnProps.hasBeforeContent + (side === _constants.Sides.Start ? 1 : 2 + columnProps.hasIconStart + columnProps.hasSecondaryTitleEnd + columnProps.hasSecondaryTitleStart));
}, function (props) {
  return props.iconAlignment;
}, function (props) {
  return props.shouldBeButton ? getIconButtonAdjustment(props.size) : 0;
}, function (props) {
  return props.shouldBeButton && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([""])));
}, function (props) {
  return props.renderIconSpacer && 'visibility: hidden;';
});

exports.IconContainer = IconContainer;

var GridSeparatorContainer = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  grid-row: -1;\n  grid-column-start: ", ";\n  grid-column-end: ", ";\n  margin-right: ", ";\n  ", ";\n"])), function (props) {
  return props.gridColumnStart;
}, function (props) {
  return props.type ? -1 : 'none';
}, function (props) {
  return "-".concat(props.insetSize, "px");
}, function (_ref3) {
  var type = _ref3.type,
      isSquished = _ref3.isSquished,
      insetSize = _ref3.insetSize;
  return (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    margin-left: ", "px;\n    margin-bottom: ", "px;\n    margin-top: ", "px;\n  "])), type === _componentSeparator["default"].Types.InsetBorder ? 0 : -insetSize, isSquished ? -insetSize / 2 : -insetSize, isSquished ? insetSize / 2 - 1 : insetSize - 1);
});

exports.GridSeparatorContainer = GridSeparatorContainer;